import React, { useEffect } from "react";
import {
  AlertTabContentWrapper,
  AlertTabMessage,
} from "../Cfc/CfcAlert.styles";
import { NewRequisitionType } from "../NewRequisition/types";
import {
  RedrawFooter,
  RedrawMessage,
  RedrawTableView,
  useRedrawTableState,
} from "./RedrawTableShared";

interface RedrawAlertTabContentProps {
  redrawDrafts: NewRequisitionType[];
  onViewOrders: () => void;
  onRowClick: (patientName: string) => void;
  onEditOrder?: (order: NewRequisitionType) => void;
  onDismiss?: (order: NewRequisitionType) => void;
  resetSignal?: unknown;
  onBusyChange?: (isBusy: boolean) => void;
}

export const RedrawAlertTabContent = ({
  redrawDrafts,
  onViewOrders,
  onRowClick,
  onEditOrder,
  onDismiss,
  resetSignal,
  onBusyChange,
}: RedrawAlertTabContentProps): React.ReactElement => {
  const state = useRedrawTableState({
    redrawDrafts,
    onRowClick,
    resetSignal,
  });

  useEffect(() => {
    onBusyChange?.(state.isBusy);
  }, [state.isBusy, onBusyChange]);

  return (
    <AlertTabContentWrapper>
      <AlertTabMessage>
        <RedrawMessage />
      </AlertTabMessage>
      <RedrawTableView
        redrawDrafts={redrawDrafts}
        state={state}
        onEditOrder={onEditOrder}
        onDismiss={onDismiss}
        flushMargins
      />
      <RedrawFooter state={state} onViewOrders={onViewOrders} />
    </AlertTabContentWrapper>
  );
};
